export function calculate(income, duration) {
    let taishokuKoujyo;
    if (income === null) {
        income = 0;
    }
    if (duration <= 5 || duration === null) {
        taishokuKoujyo = 0;
        income = 0;
    } else if (duration > 5 && duration <= 20) {
        taishokuKoujyo = 40 * duration;
    } else {
        taishokuKoujyo = 800 + 70 * (duration - 20);
    }
    let taishokuShotoku = (income - taishokuKoujyo) * 0.5;
    if (taishokuShotoku < 0) {
        taishokuShotoku = 0;
    }
    // console.log(taishokuShotoku);
    let shotokuZei, shotokuZeiritsu, shotokuKoujyo;
    if (taishokuShotoku === 0) {
        shotokuZeiritsu = 0;
        shotokuKoujyo = 0;
        shotokuZei = 0;
    } else if (taishokuShotoku < 195) {
        shotokuZeiritsu = 0.05;
        shotokuKoujyo = 0;
        shotokuZei = (taishokuShotoku * shotokuZeiritsu) * 1.021;
    } else if (taishokuShotoku > 195 && taishokuShotoku <= 330) {
        shotokuZeiritsu = 0.1;
        shotokuKoujyo = 9.75;
        shotokuZei = (taishokuShotoku * shotokuZeiritsu - shotokuKoujyo) * 1.021;
    } else if (taishokuShotoku > 330 && taishokuShotoku <= 695) {
        shotokuZeiritsu = 0.2;
        shotokuKoujyo = 42.75;
        shotokuZei = (taishokuShotoku * shotokuZeiritsu - shotokuKoujyo) * 1.021;
    } else if (taishokuShotoku > 695 && taishokuShotoku <= 900) {
        shotokuZeiritsu = 0.23;
        shotokuKoujyo = 63.6;
        shotokuZei = (taishokuShotoku * shotokuZeiritsu - shotokuKoujyo) * 1.021;
    } else if (taishokuShotoku > 900 && taishokuShotoku <= 1800) {
        shotokuZeiritsu = 0.33;
        shotokuKoujyo = 153.6;
        shotokuZei = (taishokuShotoku * shotokuZeiritsu - shotokuKoujyo) * 1.021;
    } else if (taishokuShotoku > 1800 && taishokuShotoku <= 4000) {
        shotokuZeiritsu = 0.4;
        shotokuKoujyo = 279.6;
        shotokuZei = (taishokuShotoku * shotokuZeiritsu - shotokuKoujyo) * 1.021;
    } else if (taishokuShotoku > 4000) {
        shotokuZeiritsu = 0.45;
        shotokuKoujyo = 479.6;
        shotokuZei = (taishokuShotoku * shotokuZeiritsu - shotokuKoujyo) * 1.021;
    }
    // console.log(shotokuZeiritsu);
    const shimin = taishokuShotoku * 0.06;
    const kenmin = taishokuShotoku * 0.04;
    const tedori = income - (shotokuZei + shimin + kenmin);
    let result = {};
    result.taishokuKoujyo = taishokuKoujyo;
    result.taishokuShotoku = taishokuShotoku;
    result.shotokuZeiritsu = shotokuZeiritsu;
    result.shotokuKoujyo = shotokuKoujyo;
    result.shotokuZei = shotokuZei;
    result.shimin = shimin;
    result.kenmin = kenmin;
    result.tedori = tedori;
    // console.log(result);
    return result;
};

export function forList(income, duration) {
    const result = calculate(income, duration);
    let list = [];
    list[0] = [{ name: '退職金手取額', value: `${Intl.NumberFormat().format(Math.round(result.tedori))} 万円` }];
    list[1] = [{ name: '退職所得控除', value: `${new Intl.NumberFormat().format(Math.round(result.taishokuKoujyo))} 万円` }, 
                { name: '退職所得', value: `${new Intl.NumberFormat().format(Math.round(result.taishokuShotoku))} 万円` }, 
                { name: '所得税率', value: `${result.shotokuZeiritsu * 100} %` }, 
                { name: '税控除額', value: `${new Intl.NumberFormat().format(Math.round(result.shotokuKoujyo))} 万円` }];
    list[2] = [{ name: '所得税', value: `${new Intl.NumberFormat().format(Math.round(result.shotokuZei))} 万円` }, 
                { name: '市民税(住民税)', value: `${new Intl.NumberFormat().format(Math.round(result.shimin))} 万円` }, 
                { name: '県民税(住民税)', value: `${new Intl.NumberFormat().format(Math.round(result.kenmin))} 万円` }];
    return list;
};

export function forList2(meyasu, duration) {
    if (meyasu === null) {
        meyasu = 0;
    }
    if (duration === null) {
        duration = 0;
    }
    const result = calculate(meyasu, duration);
    const zeikin = meyasu - result.tedori;
    // console.log('zeikin:', zeikin);
    let list = [{ name: '退職金目安', value: `${Intl.NumberFormat().format(Math.round(meyasu))} 万円` },
        { name: '税金', value: `${Intl.NumberFormat().format(Math.round(zeikin))} 万円` },
        { name: '税引後手取', value: `${Intl.NumberFormat().format(Math.round(result.tedori))} 万円` },
        { name: '税率', value: `${zeikin===0 ? 0 : (Intl.NumberFormat().format(Math.round((zeikin / meyasu) * 100 * 10)/10))} %` }
    ];
    return list;
};